import { render, staticRenderFns } from "./PowerBiTabs.vue?vue&type=template&id=08ffef20&scoped=true&"
import script from "./PowerBiTabs.vue?vue&type=script&lang=ts&"
export * from "./PowerBiTabs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ffef20",
  null
  
)

export default component.exports